import React, { useEffect, useState } from 'react';
import { Modal, Select, message } from 'antd';
import { changeSubnetGroup } from '~lib/netconnClient';
import constants from '~util/constants';
import handleAuthErr from '~util/handleAuthErr';
import logger from '~util/logger';

const SubnetGroupChangeModal = ({ config, onClose, systemSubnetGroups, updateConfig, visible }) => {
  const [subnetGroups, setSubnetGroups] = useState();
  const [selectedSubnetGroup, setSelectedSubnetGroup] = useState();
  const [loading, setLoading] = useState(false);

  const { Option } = Select;

  useEffect(() => {
    if (!!systemSubnetGroups?.filter) {
      const filteredSubnets = systemSubnetGroups
        .filter(subnetGroup => subnetGroup !== config?.subnetGroup)
        .sort();

      if (filteredSubnets?.length === 1) setSelectedSubnetGroup(filteredSubnets[0]);
      else setSubnetGroups(filteredSubnets);
    }
  }, [systemSubnetGroups, config]);

  const close = () => {
    // Reset state, as the Modal component is not actually unmounted when closed (set to "not visible")
    setSelectedSubnetGroup();
    onClose();
  };

  const handleConfirm = () => {
    if (!!selectedSubnetGroup) {
      setLoading(true);
      changeSubnetGroup(config, selectedSubnetGroup)
        .then(data => {
          updateConfig(data);
          setLoading(false);
          close();
        })
        .catch(
          handleAuthErr(err => {
            logger.error(err);
            message.error(constants.API_ERR_MESSAGE, 5);
            setLoading(false);
            close();
          })
        );
    }
  };

  return (
    <Modal
      cancelButtonProps={{ type: 'link', disabled: loading }}
      closable={false}
      confirmLoading={loading}
      maskClosable={!loading}
      okButtonProps={{
        disabled: !selectedSubnetGroup,
      }}
      okText="Confirm"
      onCancel={close}
      onOk={handleConfirm}
      style={{ display: 'flex', justifyContent: 'center' }}
      title="Change Subnet Group"
      visible={visible}
    >
      <span>
        Select a subnet group:
        <Select
          disabled={subnetGroups?.length === 1 || loading}
          onSelect={value => setSelectedSubnetGroup(value)}
          placeholder="Subnet"
          style={{ marginLeft: '0.5rem', width: 120 }}
          value={selectedSubnetGroup}
        >
          {!!subnetGroups?.length &&
            subnetGroups.map(subnetGroup => (
              <Option key={subnetGroup} value={subnetGroup}>
                {subnetGroup}
              </Option>
            ))}
        </Select>
      </span>
    </Modal>
  );
};

export default SubnetGroupChangeModal;
